const ERRORCODES = {
    account_already_exists: '入力頂いたメールアドレスは既にご利用中です。',
    account_country_invalid_address: '設定頂いた国籍と住所が一致しません。',
    account_invalid: 'アカウントの設定が異なります。お手数ですが、管理会社へお問い合わせください。',
    account_number_invalid: '口座番号が異なります。お手数ですが、管理会社へお問い合わせください。',
    alipay_upgrade_required: '現在の設定ではAliPayはご利用頂けません。お手数ですが、管理会社へお問い合わせください。',
    amount_too_large: '決済金額の限度額を超過しています。個別に購入頂くか、お手数ですが、加盟店様へお問い合わせください。',
    amount_too_small: '決済金額の最低額を下回っています。お手数ですが、加盟店様へお問い合わせください。',
    api_key_expired: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    authentication_required: '認証が必要です。お手数ですが、管理会社へお問い合わせください。',
    balance_insufficient: '残高不足です。別のカードをご利用頂くか、クレジットカード会社へお問い合わせください。',
    bank_account_declined: '銀行口座の認証が取れませんでした。',
    bank_account_exists: '未登録の銀行口座です。',
    bank_account_unusable: 'ご利用頂けない銀行口座です。',
    bank_account_unverified: '未認証の銀行口座です。',
    bank_account_verification_failed: '銀行口座の確認が取れませんでした。',
    bitcoin_upgrade_required: 'BitCoinは現在の設定でご利用頂けません。お手数ですが、管理会社へお問い合わせください。',
    card_decline_rate_limit_exceeded: '入力エラーの限度数に到達しました。暫くお待ちいただいた後に再度ご入力下さい。',
    card_declined: '',
    charge_already_captured: '実売上済みのため、該当の操作はできません。',
    charge_already_refunded: 'キャンセル済みのため、該当の操作はできません。',
    charge_disputed: 'チャージバック済みのため、該当の操作はできません。',
    charge_exceeds_source_limit: '一度に処理できる回数を超過しました。お手数ですが、暫くお待ち頂いた後に再度実行してください。',
    charge_expired_for_capture: '実売上可能な期間を超過しています。',
    charge_invalid_parameter: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    country_code_invalid: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    country_unsupported: 'ご利用頂けない地域です。お手数ですが、管理会社へお問い合わせください。',
    coupon_expired: '期限切れのクーポンです。',
    customer_max_payment_methods: '支払方法の登録上限数に達しました。',
    customer_max_subscriptions: '継続決済の登録上限数に達しました。',
    email_invalid: 'メールアドレスの形式が不正です。',
    expired_card: '有効期限切れのカードです。別のカードで実行してください。',
    idempotency_key_in_use: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    incorrect_address: 'ご利用のカードと異なる住所です。正しい住所を入力してください。',
    incorrect_cvc: 'セキュリティコードが異なります。正しいセキュリティコードを入力してください。',
    incorrect_number: 'カード番号が異なります。正しいカード番号を入力してください。',
    incorrect_zip: '郵便番号が異なります。正しい郵便番号を入力してください。',
    instant_payouts_unsupported: 'デビッドカードでは本機能をご利用頂けません。別のカードにて再度実行してください。',
    intent_invalid_state: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    intent_verification_method_missing: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invalid_card_type: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invalid_characters: '利用不可能な文字を入力されました。入力内容をご確認ください。',
    invalid_charge_amount: '決済金額が不正です。決済金額をご確認頂くか、加盟店様へご連絡ください。',
    invalid_cvc: 'セキュリティコードが異なります。正しいセキュリティコードを入力してください。',
    invalid_expiry_month: '有効期限(月)が異なります。正しい有効期限を入力してください。',
    invalid_expiry_year: '有効期限(年)が異なります。正しい有効期限を入力してください。',
    invalid_number: 'カード番号が異なります。正しいカード番号を入力してください。',
    invalid_source_usage: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_no_customer_line_items: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_no_payment_method_types: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_no_subscription_line_items: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_not_editable: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_payment_intent_requires_action: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    invoice_upcoming_none: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    livemode_mismatch: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    lock_timeout: 'システムの同時処理数を超過しました。お手数ですが、暫くお待ちいただいた後に再度実行してください。',
    missing: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    not_allowed_on_standard_account: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    order_creation_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    order_required_settings: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    order_status_invalid: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    order_upstream_timeout: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    out_of_inventory: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_invalid_empty: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_invalid_integer: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_invalid_string_blank: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_invalid_string_empty: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_missing: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameter_unknown: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    parameters_exclusive: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_action_required: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_authentication_failure: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_incompatible_payment_method: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_invalid_parameter: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_payment_attempt_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_intent_unexpected_state: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_method_invalid_parameter: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_method_provider_decline: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_method_provider_timeout: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_method_unactivated: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payment_method_unexpected_state: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    payouts_not_allowed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    platform_api_key_expired: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    postal_code_invalid: '郵便番号が異なります。正しい郵便番号を入力してください。',
    processing_error: '決済処理にてエラーが発生しました。お手数ですが、お時間を空けるか別のカードにて再度実行してください。',
    product_inactive: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    rate_limit: 'システムの同時処理数を超過しました。お手数ですが、暫くお待ちいただいた後に再度実行してください。',
    resource_already_exists: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    resource_missing: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    routing_number_invalid: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    secret_key_required: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    sepa_unsupported_account: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    setup_attempt_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    setup_intent_authentication_failure: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    setup_intent_invalid_parameter: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    setup_intent_unexpected_state: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    shipping_calculation_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    sku_inactive: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    state_unsupported: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    tax_id_invalid: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    taxes_calculation_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    terminal_location_country_unsupported: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    testmode_charges_only: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    tls_version_unsupported: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    token_already_used: '使用済みのトークンです。画面に従い再度入力下さい。',
    token_in_use: '使用済みのトークンです。画面に従い再度入力下さい。',
    transfers_not_allowed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    upstream_order_creation_failed: 'システムエラーが発生しました。お手数ですが、管理会社へお問い合わせください。',
    url_invalid: 'URLの形式が異なります。正しいURLの形式で入力してください。',
};
const DECLINE_CODES = {
    authentication_required: 'カードの認証ができませんでした。お手数ですが、再度実行してください。',
    approve_with_id: 'カードの認証ができませんでした。お手数ですが、再度実行してください。',
    call_issuer: 'トークンの取得に失敗しました。お手数ですが、クレジットカード会社へお問い合わせください。',
    card_not_supported: '対応していないカードのため、別のカードで実行頂くか、クレジットカード会社へお問い合わせください。',
    card_velocity_exceeded: '残高不足のため、別のカードで実行頂くか、クレジットカード会社へお問い合わせください。',
    currency_not_supported: 'ご利用頂いたカードでは通貨に対応いません。別のカードをご利用頂くか、クレジットカード会社へお問い合わせ下さい。',
    do_not_honor: 'トークンの取得に失敗しました。お手数ですが、カード会社へお問い合わせください。',
    do_not_try_again: 'トークンの取得に失敗しました。お手数ですが、カード会社へお問い合わせください。',
    duplicate_transaction: '既に決済済みです。メールをご確認頂くか、加盟店様へお問い合わせください。',
    expired_card: '有効期限切れのカードです。別のカードをご利用ください。',
    generic_decline: 'セキュリティ等の理由より、エラーが発生しました。お手数ですが、クレジットカード会社へお問い合わせください。',
    incorrect_number: '正しいカード番号をご入力ください。',
    incorrect_cvc: '正しいセキュリティコードをご入力ください',
    incorrect_pin: '正しい暗証番号をご入力ください。',
    incorrect_zip: '正しい郵便番号をご入力ください。',
    insufficient_funds: '限度額不足です。別のカードで再度実行してください。',
    invalid_account: 'システムエラーが発生しました。お手数ですが、管理会社へご連絡ください。',
    invalid_amount: 'システムエラーが発生しました。お手数ですが、管理会社へご連絡ください。',
    invalid_cvc: '正しいセキュリティコードを入力してください。',
    invalid_expiry_month: '正しい有効期限(月)を入力してください。',
    invalid_expiry_year: '正しい有効期限(年)を入力してください。',
    invalid_number: '正しいカード番号を入力してください。',
    invalid_pin: '正しい暗唱番号を入力してください。',
    issuer_not_available: 'ご利用頂けないクレジットカードです。再度実行頂くか、クレジットカード会社へご連絡ください。',
    lost_card: 'ご利用頂けないカードです。',
    merchant_blacklist: 'ご利用頂けないカードです。',
    new_account_information_available: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    no_action_taken: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    not_permitted: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    offline_pin_required: '暗唱番号を再度入力ください。',
    online_or_offline_pin_required: '暗唱番号を再度入力ください。',
    pickup_card: 'ご利用頂けないカードです。',
    pin_try_exceeded: '暗証番号の入力限度数に到達しました。お手数ですが、クレジットカード会社へお問い合わせください。',
    processing_error: '処理中にエラーが発生しました。お手数ですが、時間を空けて再度実行してください。',
    reenter_transaction: '処理中にエラーが発生しました。お手数ですが、時間を空けて再度実行してください。',
    restricted_card: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    revocation_of_all_authorizations: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    revocation_of_authorization: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    security_violation: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    service_not_allowed: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    stolen_card: 'ご利用頂けないカードです。',
    stop_payment_order: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    testmode_decline: 'テストモードのため、管理会社、もしくは加盟店様へご連絡ください。',
    transaction_not_allowed: 'ご利用頂けないカードです。お手数ですが、クレジットカード会社へお問い合わせください。',
    try_again_later: '処理中です。お手数ですが、再度実行頂くか、時間をおいて再度実行してください。',
    withdrawal_count_limit_exceeded: '残高不足のため、別のカードで実行頂くか、クレジットカード会社へお問い合わせください。',
};
export var StripeErrorCode;
(function (StripeErrorCode) {
    /**
     * @param {String} declineCode
     */
    function declineCodeToMsg(declineCode) {
        const msg = Object.entries(DECLINE_CODES).filter(p => p[0] === declineCode);
        return msg.length > 0 ? msg[0][1] : '';
    }
    StripeErrorCode.declineCodeToMsg = declineCodeToMsg;
    /**
     * @param {String} errorCode
     */
    function errorCodeToMsg(errorCode, declineCode) {
        const errorMsg = Object.entries(ERRORCODES).filter(p => p[0] === errorCode);
        if (errorMsg.length > 0 && errorMsg[0][1].length > 0) {
            return errorMsg[0][1];
        }
        const declineMsg = declineCodeToMsg(declineCode);
        return declineMsg;
    }
    StripeErrorCode.errorCodeToMsg = errorCodeToMsg;
})(StripeErrorCode || (StripeErrorCode = {}));
